import React, { useState } from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import director1 from "../assets/director1.jpg";
import director2 from "../assets/director2.jpg";
import videoBg from "../assets/company-video.mp4";
import profileImg from "../assets/mslogo1.png";
import BuildingImg2 from "../assets/ms-building.jpeg";
import BuildingImg from "../assets/ms-building2.png";

export default function AboutUsPage() {
  const [selectedDirector, setSelectedDirector] = useState(null);

  /*const directors = [
    {
      img: director1,
      name: "Mr. Suchit Parikh",
      role: "Founder & Director",
      message:
        "At MS Education, our vision is to redefine international education consulting through transparency and student-first thinking. Your dreams are our mission.",
    },
    {
      img: director2,
      name: "Mr. Kaushik Barot",
      role: "Founder & Director",
      message:
        "Guiding students to a global future has always been our passion. We believe in personalized, ethical, and effective visa solutions.",
    },
  ]; */

  return (
    <div className="w-full overflow-x-hidden bg-gradient-to-br from-[#F9F4EF] to-[#EFE5DB] text-[#002B5B] font-sans">
      {/* Hero Section */}
      <div className="relative h-[80vh] w-full overflow-hidden">
        <video
          autoPlay
          muted
          loop
          className="absolute w-full h-full object-cover"
        >
          <source src={videoBg} type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black bg-opacity-60 flex items-center justify-center">
          <h1 className="text-6xl md:text-8xl font-extrabold text-white animate-typing whitespace-nowrap overflow-hidden border-r-4 border-white pr-4 shadow-lg">
            About Us
          </h1>
        </div>
      </div>

      {/* Intro Section */}
      <section className="relative z-10 bg-white py-20 px-6">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 items-center bg-[#FDF9F4] rounded-3xl shadow-2xl p-10">
          <motion.div
            className="relative col-span-1 flex justify-center overflow-visible"
            initial={{ scale: 0.9, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
          >
            <div className="relative w-60 h-60 overflow-visible">
              {/* Glow background */}
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#B48B5F]/20 to-white blur-2xl z-[-1]" />

              {/* Decorative Emojis */}
              <div className="absolute -top-10 -left-10 text-5xl opacity-20 animate-pulse select-none pointer-events-none">
                🎓
              </div>
              <div className="absolute -bottom-10 -right-10 text-4xl opacity-20 animate-bounce select-none pointer-events-none">
                🌍
              </div>

              {/* Profile Image */}
              <img
                src={profileImg}
                alt="MS Education Team"
                className="rounded-full w-full h-full object-contain border-4 border-[#B48B5F] shadow-lg bg-white"
              />

              {/* Years Badge */}
              <div className="absolute bottom-[-10px] right-[-10px] bg-[#B48B5F] text-white px-3 py-1 rounded-full text-xs shadow-md">
                <CountUp end={25} duration={2} />+ Years
              </div>
            </div>
          </motion.div>

          <motion.div
            className="col-span-2"
            initial={{ x: 50, opacity: 0 }}
            whileInView={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.7 }}
          >
            <h2 className="text-4xl font-bold mb-2 text-[#5C3D2E]">
              Welcome to MS Education
            </h2>
            <div className="w-20 h-1 bg-[#B48B5F] rounded-full mb-4" />
            <p className="text-lg leading-relaxed text-gray-700">
              With over{" "}
              <span className="font-semibold text-[#B48B5F]">25 years</span> of
              experience, MS Education has empowered thousands of students to
              realize their dreams of international education. Headquartered in
              Anand, Gujarat, we offer{" "}
              <span className="font-medium text-[#5C3D2E]">
                expert visa consulting
              </span>
              ,
              <span className="font-medium text-[#5C3D2E]">
                {" "}
                global admission guidance
              </span>
              , and
              <span className="font-medium text-[#5C3D2E]">
                {" "}
                student mentorship
              </span>{" "}
              across India.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Our Directors */}
      {/*
      <section className="bg-gradient-to-br from-[#F1ECE6] to-[#DED5CB] py-20 px-6">
        <h2 className="text-4xl font-bold text-center mb-16 text-[#5C3D2E]">Our Directors</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 justify-items-center max-w-5xl mx-auto">
          {directors.map((dir, index) => (
            <motion.div
              key={index}
              whileHover={{ y: -8, scale: 1.03 }}
              onClick={() => setSelectedDirector(dir)}
              className="cursor-pointer bg-white/60 backdrop-blur-lg border border-[#E5DCC8] rounded-2xl shadow-lg w-72 transition-transform duration-300"
            >
              <img src={dir.img} alt={dir.name} className="w-full h-60 object-cover rounded-t-2xl" />
              <div className="p-5 text-center">
                <h3 className="font-bold text-2xl text-[#002B5B]">{dir.name}</h3>
                <p className="text-sm text-gray-700 italic mt-1">{dir.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      */}

      {/* Modal */}
      {/*
        {selectedDirector && (
          <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50 px-4">
            <div className="bg-white rounded-xl max-w-md w-full p-6 relative shadow-xl">
              <button
                className="absolute top-3 right-4 text-xl text-gray-600 hover:text-black"
                onClick={() => setSelectedDirector(null)}
              >
                &times;
              </button>
              <img src={selectedDirector.img} className="w-32 h-32 object-cover rounded-full mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-center text-[#002B5B]">{selectedDirector.name}</h3>
              <p className="text-center italic text-sm text-gray-500 mb-3">{selectedDirector.role}</p>
              <p className="text-gray-700 text-center">{selectedDirector.message}</p>
            </div>
          </div>
        )}
      </section>
      */}

      {/* Expertise */}
      <section className="py-20 px-6 bg-[#FAF8F5]">
        <h2 className="text-4xl font-bold text-center mb-14 text-[#5C3D2E]">
          Our Expertise
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 max-w-6xl mx-auto">
          {[
            {
              icon: "🎓",
              title: "25+ Years of Experience",
              desc: "Trusted by thousands of students across India since 1999.",
            },
            {
              icon: "📄",
              title: "10,000+ Cases Handled",
              desc: "Proven track record of visa and university application success.",
            },
            {
              icon: "✅",
              title: "95% Visa Success Rate",
              desc: "One of the highest approval rates in the industry.",
            },
            {
              icon: "🌍",
              title: "Global University Network",
              desc: "Strong affiliations with 200+ universities worldwide.",
            },
            {
              icon: "🧭",
              title: "Career Counseling",
              desc: "Helping students find their best-fit program and country.",
            },
            {
              icon: "📝",
              title: "SOP & Interview Prep",
              desc: "Crafting compelling personal statements and mock interviews.",
            },
          ].map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              viewport={{ once: true }}
              className="bg-white border border-[#B48B5F] rounded-2xl px-8 py-8 text-center shadow-lg hover:shadow-xl transition hover:scale-105"
            >
              <div className="text-5xl mb-4">{item.icon}</div>
              <h3 className="text-xl font-semibold text-[#002B5B] mb-2">
                {item.title}
              </h3>
              <p className="text-gray-700">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Achievements Section */}
      <section className="py-20 px-6 bg-[#F8F1E9]">
        <h2 className="text-4xl font-bold text-center mb-14 text-[#5C3D2E]">
          Our Achievements
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 max-w-6xl mx-auto text-center">
          {[
            {
              icon: "🏆",
              stat: "50+ Awards",
              desc: "Recognized by national and international education bodies.",
            },
            {
              icon: "🎓",
              stat: "10,000+ Students Guided",
              desc: "Thousands of successful study abroad journeys.",
            },
            {
              icon: "🌎",
              stat: "25+ Countries",
              desc: "Admissions and visas supported across the globe.",
            },
            {
              icon: "🤝",
              stat: "200+ Partner Universities",
              desc: "Strong ties with top institutions worldwide.",
            },
          ].map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              viewport={{ once: true }}
              className="bg-white border border-[#B48B5F] rounded-2xl px-6 py-10 shadow-md hover:shadow-xl transition hover:scale-105"
            >
              <div className="text-5xl mb-3">{item.icon}</div>
              <h3 className="text-2xl font-bold text-[#002B5B] mb-2">
                {item.stat}
              </h3>
              <p className="text-gray-700">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <section className="py-20 px-6 bg-gradient-to-br from-[#F9F4EF] to-[#EFE5DB]">
        <h2 className="text-4xl font-bold text-center mb-14 text-[#5C3D2E]">
          Our Vision, Mission & Commitment
        </h2>

        <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">
          {[
            {
              icon: "🌟",
              title: "Vision",
              desc: "To empower every student with the opportunity to study globally.",
            },
            {
              icon: "🎯",
              title: "Mission",
              desc: "To deliver honest, transparent, and effective overseas education guidance.",
            },
            {
              icon: "🤝",
              title: "Commitment",
              desc: "We’re dedicated to providing best-in-class support for your future.",
            },
          ].map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.2, duration: 0.6 }}
              viewport={{ once: true }}
              className="bg-white/70 backdrop-blur-lg border border-[#DDD2C4] rounded-2xl p-8 shadow-xl hover:shadow-2xl hover:scale-105 transition-transform duration-300 text-center"
            >
              <div className="text-5xl mb-4">{item.icon}</div>
              <h3 className="text-2xl font-bold text-[#002B5B] mb-3">
                {item.title}
              </h3>
              <p className="text-[#002B5B] text-lg">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Branches */}
      <section className="bg-gradient-to-br from-[#f8f5f2] to-[#eae4dc] py-20 px-6">
  <div className="max-w-7xl mx-auto">
    <h2 className="text-4xl font-bold text-center mb-12 text-[#003366]">
      Our Branches
    </h2>

    {/* Large Screen Layout */}
    <div className="hidden md:block relative rounded-3xl overflow-hidden shadow-xl">
      {/* Building Image */}
      <img
        src={BuildingImg}
        alt="Consultancy Building"
        className="w-full h-full object-cover rounded-3xl"
      />

      {/* Overlay Card - top right */}
      <div className="absolute top-20 right-28 backdrop-blur-md px-8 py-6 rounded-2xl shadow-lg w-[390px]">
        <h3 className="text-xl font-semibold text-[#003366] mb-4 text-center">
          Branches Across Gujarat
        </h3>
        <div className="grid grid-cols-1 gap-4 text-center">
          {[
            "Anand (H.O)",
            "Borsad",
            "Vadodara",
            "Ahmedabad - Navrangpura",
            "Ahmedabad - Maninagar",
            "Navsari",
            "Surat",
            "Nadiad",
            "Jamnagar",
          ].map((branch, idx) => (
            <div
              key={idx}
              className="px-4 py-3 bg-white border border-primary-brown shadow-md rounded-lg font-medium text-[#003366] text-sm transition-all cursor-pointer"
            >
              {branch}
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Mobile Layout */}
    <div className="md:hidden flex flex-col items-center gap-6">
      {/* Different Image */}
      <img
        src={BuildingImg2}
        alt="Consultancy Building Mobile"
        className="w-full h-auto rounded-2xl shadow-lg"
      />

      {/* Branches under the image */}
      <div className="bg-white/95 backdrop-blur-md px-6 py-5 rounded-2xl shadow-lg w-full">
        <h3 className="text-lg font-semibold text-[#003366] mb-4 text-center">
          Branches Across Gujarat
        </h3>
        <div className="grid grid-cols-2 gap-3 text-center">
          {[
            "Anand (H.O)",
            "Borsad",
            "Vadodara",
            "Ahmedabad - Navrangpura",
            "Ahmedabad - Maninagar",
            "Navsari",
            "Surat",
            "Nadiad",
            "Jamnagar",
          ].map((branch, idx) => (
            <div
              key={idx}
              className="flex items-center rounded-lg justify-center px-4 py-3 bg-white border border-primary-brown shadow-md font-medium text-[#003366] text-sm transition-all cursor-pointer"
            >
              {branch}
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
</section>

      {/* <section className="bg-gradient-to-br from-[#f8f5f2] to-[#eae4dc] py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-12 text-[#003366]">
            Our Branches
          </h2>

          <div className="relative rounded-3xl overflow-hidden shadow-xl">
           
            <img
              src={BuildingImg}
              alt="Consultancy Building"
              className="h-full w-auto object-cover rounded-3xl"
            />

         
            <div className="absolute right-8 left-1/2 transform -translate-x-1/2 bg-white/90 backdrop-blur-md px-8 py-6 rounded-2xl shadow-lg w-[90%] md:w-[70%]">
              <h3 className="text-2xl font-semibold text-[#003366] mb-4 text-center">
                Branches Across Gujarat
              </h3>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 text-center">
                {[
                  "Anand (H.O)",
                  "Borsad",
                  "Vadodara",
                  "Ahmedabad - Navrangpura",
                  "Ahmedabad - Maninagar",
                  "Navsari",
                  "Surat",
                  "Nadiad",
                  "Jamnagar",
                ].map((branch, idx) => (
                  <div
                    key={idx}
                    className="px-4 py-2 bg-[#003366]/10 rounded-lg font-medium text-[#003366] text-sm hover:bg-[#003366] hover:text-white transition-all cursor-pointer"
                  >
                    {branch}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="bg-primary-cream py-20 px-6">
        <div className="max-w-7xl mx-auto">
         

          <div className="flex flex-col lg:flex-row items-center gap-12">
          

            <div className="w-full">
            <h2 className="text-4xl font-bold text-center mb-12 text-[#003366] lg:text-left">
            Our Branches
          </h2>
              <div className="flex flex-wrap justify-center lg:justify-start gap-4 text-center">
                {[
                  "Anand (H.O)",
                  "Borsad",
                  "Vadodara",
                  "Ahmedabad - Navrangpura",
                  "Ahmedabad - Maninagar",
                  "Navsari",
                  "Surat",
                  "Nadiad",
                  "Jamnagar",
                ].map((branch, idx) => (
                  <div
                    key={idx}
                    className="px-4 sm:px-6 py-3 bg-white rounded-full shadow-md text-[#4B2E2F] font-medium text-sm sm:text-lg hover:bg-[#003366] hover:text-white transition-all duration-300 ease-in-out cursor-pointer"
                  >
                    {branch}
                  </div>
                ))}
              </div>
            </div>
              <div className="w-full lg:w-1/2 flex justify-center">
              <div className="">
              <img
  src={BuildingImg}
  alt="Our Branches Network"
  className="w-full max-h-[340px] h-auto 
             rounded-2xl object-contain
             shadow-2xl
             shadow-[#212121]
             border-2 border-[#B48B5F]
             hover:rotate-0 transition-transform duration-500"
/>

              </div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
}
